<shared-modal-container headline="Session Expiring" [showCloseButton]="false" [isDialogPositionUp]="isDialogPositionUp">
  <div class="bg-light px-4 pb-4 w-100">
    <div class="text-center pb-4">
      You will be logged out in {{ remainingSeconds }} seconds due to inactivity. Do you want to stay logged in?
    </div>

    <div class="flex-column p-3 gap-3">
      <button pButton class="m-a p-button p-button-outline centered w-100" (click)="logout()">Logout</button>
      <button pButton class="m-a p-button p-button-primary centered w-100" (click)="stayLogged()">Stay Logged In</button>
    </div>
  </div>
</shared-modal-container>
